import { Currency } from './currency'

export enum Country {
  NL = 'Netherlands',
  GB = 'United Kingdom',
  US = 'United States',
  PL = 'Poland',
  AT = 'Austria',
  IT = 'Italy',
  FI = 'Finland',
  DE = 'Germany',
  DK = 'Denmark',
  EE = 'Estonia',
  ES = 'Spain',
  MT = 'Malta',
  NO = 'Norway',
  SE = 'Sweden',
  BE = 'Belgium',
  CZ = 'Czech Republic',
  BR = 'Brazil',
  MX = 'Mexico',
  PT = 'Portugal',
  CN = 'China',
  JP = 'Japan',
  LT = 'Lithuania',
  LV = 'Latvia'
}

export const CountryCode: Record<Country, string> = {
  [Country.US]: 'US',
  [Country.GB]: 'GB',
  [Country.NL]: 'NL',
  [Country.PL]: 'PL',
  [Country.AT]: 'AT',
  [Country.IT]: 'IT',
  [Country.FI]: 'FI',
  [Country.DE]: 'DE',
  [Country.DK]: 'DK',
  [Country.EE]: 'EE',
  [Country.ES]: 'ES',
  [Country.MT]: 'MT',
  [Country.NO]: 'NO',
  [Country.SE]: 'SE',
  [Country.BE]: 'BE',
  [Country.CZ]: 'CZ',
  [Country.BR]: 'BR',
  [Country.MX]: 'MX',
  [Country.PT]: 'PT',
  [Country.CN]: 'CN',
  [Country.JP]: 'JP',
  [Country.LT]: 'LT',
  [Country.LV]: 'LV'
}

export const CountryFlag: Record<Country, string> = {
  [Country.US]: 'https://www.paypalobjects.com/fpti/countryflags/us.svg',
  [Country.GB]: 'https://www.paypalobjects.com/fpti/countryflags/gb.svg',
  [Country.NL]: 'https://www.paypalobjects.com/fpti/countryflags/nl.svg',
  [Country.PL]: 'https://www.paypalobjects.com/fpti/countryflags/pl.svg',
  [Country.AT]: 'https://www.paypalobjects.com/fpti/countryflags/at.svg',
  [Country.IT]: 'https://www.paypalobjects.com/fpti/countryflags/it.svg',
  [Country.FI]: 'https://www.paypalobjects.com/fpti/countryflags/fi.svg',
  [Country.DE]: 'https://www.paypalobjects.com/fpti/countryflags/de.svg',
  [Country.DK]: 'https://www.paypalobjects.com/fpti/countryflags/dk.svg',
  [Country.EE]: 'https://www.paypalobjects.com/fpti/countryflags/ee.svg',
  [Country.ES]: 'https://www.paypalobjects.com/fpti/countryflags/es.svg',
  [Country.MT]: 'https://www.paypalobjects.com/fpti/countryflags/mt.svg',
  [Country.NO]: 'https://www.paypalobjects.com/fpti/countryflags/no.svg',
  [Country.SE]: 'https://www.paypalobjects.com/fpti/countryflags/se.svg',
  [Country.BE]: 'https://www.paypalobjects.com/fpti/countryflags/be.svg',
  [Country.CZ]: 'https://www.paypalobjects.com/fpti/countryflags/cz.svg',
  [Country.BR]: 'https://www.paypalobjects.com/fpti/countryflags/br.svg',
  [Country.MX]: 'https://www.paypalobjects.com/fpti/countryflags/mx.svg',
  [Country.PT]: 'https://www.paypalobjects.com/fpti/countryflags/pt.svg',
  [Country.CN]: 'https://www.paypalobjects.com/fpti/countryflags/cn.svg',
  [Country.JP]: 'https://www.paypalobjects.com/fpti/countryflags/jp.svg',
  [Country.LT]: 'https://www.paypalobjects.com/fpti/countryflags/lt.svg',
  [Country.LV]: 'https://www.paypalobjects.com/fpti/countryflags/lv.svg'
}

// FIXME - THESE ARE PLACEHOLDER VALUES FOR NOW ...
export const CountryCurrency: Record<Country, string> = {
  [Country.US]: Currency.USD,
  [Country.GB]: Currency.GBP,
  [Country.NL]: Currency.EUR,
  [Country.PL]: Currency.EUR,
  [Country.AT]: Currency.EUR,
  [Country.IT]: Currency.EUR,
  [Country.FI]: Currency.EUR,
  [Country.DE]: Currency.EUR,
  [Country.DK]: Currency.EUR,
  [Country.EE]: Currency.EUR,
  [Country.ES]: Currency.EUR,
  [Country.MT]: Currency.EUR,
  [Country.NO]: Currency.EUR,
  [Country.SE]: Currency.EUR,
  [Country.BE]: Currency.EUR,
  [Country.CZ]: Currency.EUR,
  [Country.BR]: Currency.BRL,
  [Country.MX]: Currency.MXN,
  [Country.PT]: Currency.EUR,
  [Country.CN]: Currency.USD,
  [Country.JP]: Currency.JPY,
  [Country.LT]: Currency.EUR,
  [Country.LV]: Currency.EUR
}
